import { ADDONS_KALLAX as appId } from "./constants";
import storedCatalog from "./rangeConfig/catalog.json";
import storedTemplates from "./rangeConfig/template.json";
import OnDragInsertSystem from "./systems/OnDragInsertSystem";
import { RangeApi } from "@inter-ikea-storagetwo/range/dist/rangeApi";
import { getCatalogAndTemplate } from "@inter-ikea-storagetwo/range/dist/utils/catalogAndTemplateUtils";
import { systemsDefinitionList } from "./systems";
import { Segment } from "@inter-ikea-storagetwo/dexf-utils";
export class Kallax extends RangeApi {
    constructor({ core, env = Segment.production, catalogAndTemplate, }) {
        const { catalog, templates } = getCatalogAndTemplate(catalogAndTemplate, storedCatalog, storedTemplates);
        super({
            core,
            systemsDefinitionList,
            templates,
            catalog,
            env,
            appId,
            settings: {
                useAutoAdapt: false,
            },
        });
    }
    init(props) {
        var _a, _b;
        super.init(props);
        (_a = this.systemService) === null || _a === void 0 ? void 0 : _a.disableSystem("onDragInsertSystem");
        (_b = this.systemService) === null || _b === void 0 ? void 0 : _b.disableSystem("disableFrameInteractionSystem");
    }
}
export { Kallax as default, OnDragInsertSystem };
